var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "240.5333306 1601.5999818 1014.9333217999998 1032.5333216",
    id: "svg2",
    style: {
      maxHeight: 500
    },
    width: 1014.9333217999998,
    height: 1032.5333216,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,2933.3333)",
    id: "g8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 22000,0 H 0 V 22000 H 22000 V 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5272.27,14336.8 c 0,-957.3 -913.83,-1733.3 -2041.14,-1733.3 -1127.3,0 -2041.13,776 -2041.13,1733.3 0,2415.4 2634.74,4780.1 2634.74,4780.1 l 442.69,-381.7 c 0,0 -1237.05,-1096 -1792.66,-2788.1 233.8,79.3 489.16,123 756.36,123 1127.31,0 2041.14,-776 2041.14,-1733.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 10115.4,14336.8 c 0,-957.3 -913.84,-1733.3 -2041.14,-1733.3 -1127.31,0 -2041.14,776 -2041.14,1733.3 0,2415.4 2634.74,4780.1 2634.74,4780.1 l 442.69,-381.7 c 0,0 -1237.05,-1096 -1792.66,-2788.1 233.8,79.3 489.16,123 756.37,123 1127.3,0 2041.14,-776 2041.14,-1733.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 16727.7,17383.6 c 0,957.3 913.9,1733.3 2041.2,1733.3 1127.3,0 2041.1,-776 2041.1,-1733.3 0,-2415.4 -2634.7,-4780.1 -2634.7,-4780.1 l -442.7,381.7 c 0,0 1237,1096.1 1792.6,2788.2 -233.8,-79.4 -489.1,-123 -756.3,-123 -1127.3,0 -2041.2,775.9 -2041.2,1733.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11884.6,17383.6 c 0,957.3 913.8,1733.3 2041.1,1733.3 1127.4,0 2041.2,-776 2041.2,-1733.3 0,-2415.4 -2634.8,-4780.1 -2634.8,-4780.1 l -442.7,381.7 c 0,0 1237.1,1096.1 1792.7,2788.2 -233.8,-79.4 -489.2,-123 -756.4,-123 -1127.3,0 -2041.1,775.9 -2041.1,1733.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4472.41,2883.1 h -2058.2 l 1462.41,6644 H 5068.2 l -595.79,-6644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7830.52,2883.1 h -2058.2 l 1462.41,6644 h 1191.59 l -595.8,-6644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 15559,9527.1 h -2058.2 l 1462.4,-6644 h 1191.6 l -595.8,6644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#121212",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 18917.1,9527.1 h -2058.2 l 1462.4,-6644 h 1191.6 l -595.8,6644"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.76ce74cd1f9fd55827852ae558d21da2.svg";
export { ForwardRef as ReactComponent };